import { render, staticRenderFns } from "./redirectUrl.vue?vue&type=template&id=69f36c45&scoped=true&"
import script from "./redirectUrl.vue?vue&type=script&lang=js&"
export * from "./redirectUrl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69f36c45",
  null
  
)

export default component.exports